// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useLocaleValue = (item: any, attribute: string): string => {
    if (!item) return ""
    const locale = useNuxtApp().$i18n.locale

    if (locale.value === "cs") {
        return item[attribute] || ""
    }
    const englishValue = item[attribute + "_EN"] || item[attribute + "_en"]
    return englishValue || item[attribute] || ""
}
